export default __webpack_public_path__ + "8bb301ce8ecc206e261216ca9948e7c9.woff";